import { FullLoader } from 'components/atoms/FullLoader/FullLoader'

import css from './ContactsTable.module.css'

export const Spinner = <FullLoader className={css.spinner} />
export const ActionTH = (
	<th className={css.actionsHeader} key='▶️'>
		Actions
	</th>
)
